import { useState } from "react";
import { format, parse } from "date-fns";
import { CalendarIcon } from "lucide-react";
import { Calendar } from "@/components/ui/calendar";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { cn } from "@/lib/utils";

export function DatePickerField({ value, onChange, minDate, label, testId, required, placeholder = "DD/MM/YYYY" }) {
  const [open, setOpen] = useState(false);

  // Parse YYYY-MM-DD string to Date object
  const selectedDate = value ? parse(value, "yyyy-MM-dd", new Date()) : undefined;

  const handleSelect = (date) => {
    if (date) {
      // Store as YYYY-MM-DD
      onChange(format(date, "yyyy-MM-dd"));
    }
    setOpen(false);
  };

  // Display as DD/MM/YYYY
  const displayValue = selectedDate ? format(selectedDate, "dd/MM/yyyy") : "";

  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const disabledBefore = minDate ? parse(minDate, "yyyy-MM-dd", new Date()) : today;

  return (
    <div>
      {label && (
        <label className="block text-sm font-medium text-foreground mb-2">
          {label} {required && <span className="text-red-500">*</span>}
        </label>
      )}
      <Popover open={open} onOpenChange={setOpen}>
        <PopoverTrigger asChild>
          <button
            type="button"
            data-testid={testId}
            className={cn(
              "form-input w-full flex items-center justify-between text-left cursor-pointer",
              !displayValue && "text-muted-foreground"
            )}
          >
            <span>{displayValue || placeholder}</span>
            <CalendarIcon className="w-4 h-4 text-muted-foreground flex-shrink-0" />
          </button>
        </PopoverTrigger>
        <PopoverContent className="w-auto p-0" align="start" sideOffset={4}>
          <Calendar
            mode="single"
            selected={selectedDate}
            onSelect={handleSelect}
            disabled={(date) => date < disabledBefore}
            defaultMonth={selectedDate || disabledBefore}
            weekStartsOn={1}
            initialFocus
          />
        </PopoverContent>
      </Popover>
    </div>
  );
}
